import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Load Rating',
  name: 'loadRating',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'name',
      type: 'string',
      initialValue: 'Load Rating (lbs)',
    }),
    defineField({
      title: 'Rows',
      name: 'data',
      type: 'array',
      of: [
        {
          title: 'Row',
          name: 'row',
          type: 'object',
          fields: [
            defineField({
              title: 'Title',
              name: 'title',
              type: 'string',
            }),
            defineField({
              title: 'Value',
              name: 'value',
              type: 'string',
            }),
          ],
          preview: {
            select: {
              title: 'title',
              value: 'value',
            },
            prepare(selection) {
              const { title = 'Add item', value = '' } = selection || {}

              return {
                title: `${title} - ${value}`,
                subtitle: '',
              }
            },
          },
        },
      ],
    }),
  ],
})